<template>
    <div :class="['infoboard-chart', viewSize, 'col-md-12', 'col-lg-' + gridSize]">
        <div class="chart-header">
            <div class="chart-title col-xs-8">
                {{ title }}
            </div>
            <div v-if="buttons" class="chart-buttons col-xs-4" style="padding-right: 2px;">
                <div class="btn-group charts-buttons" style="margin-top: 3px">
                    <a v-if="buttons.fullscreen" class="btn btn-xs btn-default" title="Fullscreen">
                        <i class="['fa', { 'fa-expand': !fullscreen }, { 'compress': fullscreen }]"></i>
                    </a>
                    <a v-if="buttons.table && view === 'chart'" class="btn btn-xs btn-default" title="View chart"
                       @click.prevent="swapTo('chart')">
                        <i class="fa fa-table"></i>
                    </a>
                    <a v-if="buttons.chart && view === 'grid'" class="btn btn-xs btn-default" title="View grid"
                       @click.prevent="swapTo('grid')">
                        <i class="fa fa-bar-chart-o"></i>
                    </a>
                    <a v-if="buttons.export" class="btn btn-xs btn-default" title="Export"
                       @click.prevent="exportData()">
                        <i class="fa fa-download"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="chart-content" style="padding-bottom: 15px">
            <div v-if="Object.keys(chart || {}).length && view === 'chart'" class="chart-graph"
                 :style="{ display: view === 'chart' ? 'block' : 'none' }">
                <kendo-chart
                    ref="chartWidget"
                    :type="chart.type"
                    :height="height"
                    :series="chart.series"
                    :category="chart.category"
                    :format="chart.format"
                    :dataSource="chart.dataSource">
                </kendo-chart>
            </div>
            <div v-if="Object.keys(grid || {}).length && view === 'grid'" class="chart-table"
                 :style="{ display: view === 'grid' ? 'block' : 'none' }">
                <kendo-grid
                    ref="gridWidget"
                    :filename="filename"
                    :pageable="false"
                    :height="height"
                    :scrollable="grid.scrollable"
                    :columns="grid.columns"
                    :tooltip="tooltip"
                    :dataSource="grid.dataSource">
                </kendo-grid>
            </div>
        </div>
    </div>

</template>

<script>
import KendoChartComponent from '../../../shared/components/kendo-chart/kendo-chart.component';
import KendoGridComponent from '../../../shared/components/kendo-grid/kendo-grid.component.vue';

export default {
    name: 'dashboard-widget',

    props: {
        size: {
            type: String,
            default: 'normal'
        },
        gridSize: {
            type: Number,
            default: 12
        },
        height: {
            type: Number,
            default: 150
        },
        title: {
            type: String
        },
        filename: {
            type: String
        },
        buttons: {
            type: Object
        },
        grid: {
            type: Object
        },
        chart: {
            type: Object
        },
        tooltip: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        viewSize () {
            return this.fullscreen ? 'chart-expanded-size' : `chart-${this.size}-size`;
        }
    },

    data () {
        return {
            fullscreen: false,
            view: Object.keys(this.grid).length ? 'grid' : 'chart'
        };
    },

    watch: {},

    mixins: [],

    methods: {
        exportData () {
          if (this.$refs.gridWidget) {
            let exportFlag = false;
            const columnsIndex = this.$refs.gridWidget.columns
              .map((x, i) => {
                if (x.hidden) {
                  return i;
                }
                return undefined;
              })
              .filter((x) => x !== undefined);

            $(this.$refs.gridWidget.$el).data('kendoGrid').bind("excelExport", function (e) {
              if (!exportFlag) {
                columnsIndex.forEach((x) => {
                  e.sender.showColumn(x);
                });
                e.preventDefault();
                exportFlag = true;
                setTimeout(function () {
                  e.sender.saveAsExcel();
                });
              } else {
                columnsIndex.forEach((x) => {
                  e.sender.hideColumn(x);
                });
                exportFlag = false;
              }
            });

            this.$refs.gridWidget.exportTable();
          }
        },

        swapTo (name) {
            this.view = name;
        },

        getHeight () {
            return `${this.height}px`;
        }
    },

    mounted () {
    },

    destroyed () {
    },

    components: {
        kendoChart: KendoChartComponent,
        kendoGrid: KendoGridComponent
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/dashboards/components/dashboard-widget/dashboard-widget.component.vue